import { render, staticRenderFns } from "./initiatives.vue?vue&type=template&id=69927df4&scoped=true&"
import script from "./initiatives.vue?vue&type=script&lang=js&"
export * from "./initiatives.vue?vue&type=script&lang=js&"
import style0 from "./initiatives.vue?vue&type=style&index=0&id=69927df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69927df4",
  null
  
)

export default component.exports